import common from './common'
import type { AppTheme } from './types'

const light: AppTheme = {
  ...common,
  font_color: '#000000',
  font_family: 'DysonFutura',
  body_color: '#ffffff',
  primary_color: '#2C2971',
  secondary_color: '#89B641',
  border_color: '#EBEBEB',
  light_grey: '#FBFBFB',
  palette: {
    ...common.palette,
    primary: {
      900: '#2C2971',
      800: '',
      700: '',
      600: '',
      500: '',
      400: '',
      300: '',
      200: '',
      100: '',
      50: '',
    },
    secondary: {
      900: '#89B641',
      800: '',
      700: '',
      600: '',
      500: '',
      400: '',
      300: '',
      200: '',
      100: '',
      50: '',
    },
    grey: {
      900: '#000000',
      800: '#282828',
      700: '#333333',
      600: '#555555',
      500: '#919191',
      400: '',
      300: '#EBEBEB',
      200: '',
      100: '#F3F3F3',
      50: '#FBFBFB',
    },
  },
  fontSize: scale => {
    const { baseSize } = common.typography
    const baseSizeRem = baseSize / 16 // Convert base size to rem

    // Define the scaling factors for each level
    const scalingFactors = [1, 1.25, 1.5, 1.75, 2.25, 2.75, 3.25]

    // Use the scale parameter to look up the corresponding scaling factor
    const scaleFactor = scalingFactors[scale - 1] || 1

    return `${baseSizeRem * scaleFactor}rem`
  },
}

export default light
